import { Component, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { QuestionComponent } from '../abstract/question.component'
import { map, tap, share, shareReplay } from 'rxjs/operators';
import { get, max, keys, times } from 'lodash';
import { Observable } from 'rxjs';
import { BarHorizontalComponent } from '@swimlane/ngx-charts';
import { ReplyItem } from '../../../../../classes';

@Component({
  selector: 'question-afterschool',
  templateUrl: './question-afterschool.component.html',
  styleUrls: ['./question-afterschool.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class QuestionAfterschoolComponent extends QuestionComponent {
  @ViewChild(BarHorizontalComponent) chart:BarHorizontalComponent
  results:Observable<{name:string, value:number}[]> = this.relatedReplyList
  .pipe(
    map(list=>this.turnListIntoStatistics(list)),
    tap(results=>{
      const max_value = max(results.map(r=>r.value));
      if (max_value) this.xAxisTicks = times(max_value, i=>i + 1);
    }),
    shareReplay(1)
  )
  xAxisTicks:number[]
  ngOnInit () {
    this.charts.set(this.question.id, this.chart);
  }
  turnListIntoStatistics (list:ReplyItem[]) {
    const max_selection_num = max(list.map(li=>keys(get(li, ['snapshot', this.question.id])).length));
    return this.question.options.map(o=>{
      return { name:o.text, value: list.filter(li=>get(li, ['snapshot', o.question.id, o.id])).length }
    })
    .concat( // count heads by number of selection
      times(max_selection_num)
      .map(n=>n+1)
      .map(n=>{
        return { name:this.generateNthSelection(n), value: list.filter(li=>keys(get(li, ['snapshot', this.question.id])).length === n).length }
      })
    )
  }
  xAxisTickFormatting ($event) {
    return $event;
  } 
  yAxisTickFormatting (o_id:string) {
    const option = this.question.getOptions({id:o_id})[0];
    return option ? option.text : o_id;
  }
  /**
   * 
   * @param text option.text
   */
  onSelect(event:string|{name:string, value:number}) {
    let text:string;
    if (typeof event === 'object') text = event.name;
    else text = event;
    const option = this.question.getOptions({text})[0];
    if (option) {
      this.repliesPerOptionModal.open(
        option,
        this.replies.list.pipe(
          map(list=>list.filter(li=>get(li, ['snapshot', this.question.id, option.id]))),
        )
      );
    } else {
      const nth_items_selected = Number(text.replace(/\D/g, ''));
      if (nth_items_selected > 0) {
        this.repliesPerOptionModal.open(
          {text:this.generateNthSelection(nth_items_selected), question:this.question}, 
          this.replies.list.pipe(
            map(list=>list.filter(li=>get(li, ['snapshot', this.question.id]))),
            map(list=>list.filter(li=>keys(get(li, ['snapshot', this.question.id])).length === nth_items_selected)),
          )
        );
      }
    }
  }
  generateNthSelection (n:number) {
    return `${n} ê° ì í`;
  }
}
